export default {
    accountsPortal: 'ACCOUNT-PORTAL',
    donations: 'DONATIONS',
    locations: 'LOCATIONS',
    newsroom: 'NEWSROOM',
    shortURL: 'SHORT-URL',
    iamDashboard: 'IAM-DASHBOARD',
    listing: 'LISTING',
    organisations: 'ORGANISATIONS',
    getDomainList: 'getDomainList',
    deleteOrganisation: 'deleteOrganisation',
    changePlan: 'changePlan',
    manageLicense: 'manageLicense', //not working
    changeRole: 'changeRole',
    getOrganisationById: 'getOrganisationById',

    organisationList: 'organisationList',
    updateOrganisation: 'updateOrganisation',
    inviteMemberStep1: 'inviteMemberStep1',
    inviteMemberStep2: 'inviteMemberStep2',
    addPaymentMethod: 'addPaymentMethod',
    billingManagerList: 'billingManagerList',
    detachPaymentMethod: 'detachPaymentMethod',
    getAddressAndVat: 'getAddressAndVat',
    getOrgSubscription: 'getOrgSubscription',
    listInvoices: 'listInvoices',
    listPaymentMethod: 'listPaymentMethod',
    removeBillingManager: 'removeBillingManager',
    organisationPlanList: 'organisationPlanList',

    createTeam: 'createTeam',
    updateTeam: 'updateTeam',
    changeRole33: 'changeRole33',
    getTeamById: 'getTeamById', // not working
    deleteTeam: 'deleteTeam',
    getMembersByTeam: 'getMembersByTeam',
    getTeamList: 'getTeamList',
    inviteCount: 'inviteCount',
    inviteMemberStep153: 'inviteMemberStep153',
    inviteMemberStep228: 'inviteMemberStep228',
    removeMemberFromTeam: 'removeMemberFromTeam',
    cancelInvitation: 'cancelInvitation',
    failedInvitationList: 'failedInvitationList',
    pendingInvitationList: 'pendingInvitationList',

    //reporting groups
    getShortUrlById: 'getShortUrlById',
    listReportingGroup: 'listReportingGroup',
    updateReportingGroup: 'updateReportingGroup',
    createReportingGroup: 'createReportingGroup',
    updateShortUrl: 'updateShortUrl',
    createShortUrl: 'createShortUrl',
    bulkUpdateShortUrl: 'bulkUpdateShortUrl',
    getShortUrl: 'getShortUrl',

    organisationUrlList: 'organisationUrlList',
    organisationUrlCount: 'organisationUrlCount',
    memberFieldFilter: 'memberFieldFilter',


    getDonarProfile: 'getDonarProfile',
    getDonationTier: 'getDonationTier',
    getStripeAccountDetail: 'getStripeAccountDetail',
    createDonationSet: 'createDonationSet',
    createDonationTier: 'createDonationTier',
    deleteDonationSet: 'deleteDonationSet',
    deleteDonationTier: 'deleteDonationTier',
    donorsList: 'donorsList',
    updateConnectedAccount: 'updateConnectedAccount',
    updateDonationTier: 'updateDonationTier',

    checkAccountStatus: 'checkAccountStatus',

    addAuthor: 'addAuthor',
    addPublisher: 'addPublisher',
    addPublication: 'addPublication',
    
}